import {
  FormFieldConfigType,
  UploadFormField,
  INPUT_TYPES,
} from "../../../../types";
import { preProcessFormFields } from "../../../../tools";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../../constants";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allFileAttachmentsFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER,
    fields: [
      {
        name: FILE_ATTACHMENTS_CONSTANTS.PHOTOS,
        label: "Photo(s)",
        description: "Upload photos related to your claim",
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        accept: "image/*",
      } as UploadFormField,
      {
        name: FILE_ATTACHMENTS_CONSTANTS.DOCUMENTS,
        label: "Document(s)",
        description: "Upload documents related to your claim",
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        accept: ".pdf,.doc,.docx,.txt",
      } as UploadFormField,
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
